var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".h{fill:url(#d);}.i{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 20,
    y1: 0.43,
    x2: 20,
    y2: 39.74,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#cdd0d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#dcdee2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "e",
    className: "h",
    d: "M20,0h0c11.05,0,20,8.95,20,20h0c0,11.05-8.95,20-20,20h0C8.95,40,0,31.05,0,20H0C0,8.95,8.95,0,20,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f",
    className: "i",
    d: "M16.84,28.42l-5.34,1.08,1.08-5.34,4.27,4.27Zm-3.2-5.33l4.27,4.27,11.59-11.6-4.27-4.27-11.59,11.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "M16.34,27.92l-5.34,1.08,1.08-5.34,4.27,4.27Zm-3.2-5.33l4.27,4.27,11.59-11.6-4.27-4.27-11.59,11.6Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.6b75ddfa491ee39beb8b6d6d04601c4e.svg";
export { ForwardRef as ReactComponent };